import { defaultFontInput } from './constants/fontFamilies';

const FableticsMembershipHeaderBuilderComponent = {
  name: '_MembershipHeaderGreetingAndBadge_',
  inputs: [defaultFontInput],
} as const;

export default FableticsMembershipHeaderBuilderComponent;
